__turbopack_context__.v({
  "banner": "MHCF8q_banner",
  "bannerImage": "MHCF8q_bannerImage",
  "bannerPlp": "MHCF8q_bannerPlp",
  "cell": "MHCF8q_cell",
  "cellImage": "MHCF8q_cellImage",
  "grid": "MHCF8q_grid",
  "gridEqual3": "MHCF8q_gridEqual3",
  "gridSplit4": "MHCF8q_gridSplit4",
});
